const payment_gateways = {
  gateway_name: 'Passerrelles de paiements',
};

export default payment_gateways;
